/** @format */

import $ from "jquery";
import axios from "axios";
import { Input } from "antd";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import React, { useEffect, useRef, useState } from "react";
import { CloseOutlined, SearchOutlined, PlusOutlined } from "@ant-design/icons";

import Card from "../../../../components/Card";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import Chart4 from "../../../../components/Charts/Chart4";
import Minimap from "../../../../components/map/Minimap";
import { header } from "../../../../components/api/Header";
import { ExcelPrint } from "../../../../components/functions/Print";
import LoadingCard from "../../../../components/loading/loadingCard";
import { monthDays, monthName } from "../../../../components/functions/Month";
import { getEnv } from "../../../../lib/env";

function Kunlik({ region, vaqt, search, setDate, havza, boshqarma }) {
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState("");

  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [lmonth, setLmonth] = useState(month);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // 1. Endpointni aniqlab olamiz
        const endpoint = boshqarma === "havza"
            ? "/v1/region/asosiymanbalar/kunlik"
            : "/v1/region/asosiymanbalar2/kunlik";

        // 2. Havza parametri faqat "havza" tanlanganda qo'shilishi uchun shart
        const havzaParam = boshqarma === "havza" ? `&havza=${havza}` : "";

        // 3. API so'rovi
        const res = await axios.get(
            `${getEnv('REACT_APP_BASE_URL')}${endpoint}?month=${month}&vaqt=${vaqt}${havzaParam}`,
            header()
        );

        console.log(res);

        if (res && res.data) {
          // Gidromet filtrlash mantiqi faqat "havza" uchun tegishli bo'lsa,
          // uni boshqarma === "havza" sharti ichiga olish xavfsizroq
          if (boshqarma === "havza" && region === "Gidromet") {
            if (havza === 1) {
              setData(
                  res.data
                      .slice(23, 31)
                      .concat(res.data.slice(35, 48), res.data.slice(59, 63))
              );
            } else if (havza === 2) {
              setData(
                  res.data
                      .slice(0, 23)
                      .concat(res.data.slice(31, 35), res.data.slice(48, 59))
              );
            } else {
              setData(res.data);
            }
          } else {
            // ITB kelsa yoki boshqa region bo'lsa hamma ma'lumotni ko'rsatish
            setData(res.data);
          }
        }
      } catch (e) {
        console.error("Xato", e);
        // Alert foydalanuvchini bezovta qilishi mumkin,
        // yaxshisi notification (antd) ishlating
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    // MUHIM: 'boshqarma' ni bu yerga qo'shish shart!
  }, [month, vaqt, havza, boshqarma, region]);

  useEffect(() => {
    setMonth(lmonth);
  }, [lmonth]);

  const chiz = (index) => {
    removeChecked();
    let v = $("tr.tr" + index + " input");
    let checked = v[0].checked;
    v[0].checked = !checked;
    if (!checked) {
      $("tr.tr" + index).addClass("active");
    } else {
      $("tr.tr" + index).removeClass("active");
    }
    setSelectedRowKeys(index);
  };

  const removeChecked = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
  };

  const close = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
    setSelectedRowKeys("");
  };

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Asosiy manbalar",
  });

  return (
    <>
      <div className='table-box'>
        <div className='table-content-top'>
          <div className='table-top-left'>
            <Input
              prefix={<SearchOutlined className='site-form-item-icon' />}
              placeholder='Search'
              onChange={(e) => search(e.target.value)}
            />
          </div>

          <ul className='table-top-right'>
            <li>
              <NavLink
                to='/asosiymanbalar/add'
                className='btn btn-sm btn-outline-primary d-flex align-items-center'>
                Ma'lumot kiritish&nbsp;&nbsp;&nbsp;
                <PlusOutlined />
              </NavLink>
            </li>

            <li>
              <div className='d-flex'>
                <input
                  type='month'
                  className='form-control form-control-sm'
                  value={lmonth}
                  onChange={(e) => setLmonth(e.target.value)}
                />
              </div>
            </li>

            <li>
              <button className='btn p-0' onClick={() => generatePDF()}>
                <img src={print} alt='404' />
              </button>
            </li>

            <li>
              <button
                className='btn p-0'
                onClick={() =>
                  ExcelPrint("Asosiy manbalar " + region, month, "tblData")
                }>
                <img src={excel} alt='404' />
              </button>
            </li>
          </ul>
        </div>

        {loading ? (
          <LoadingCard loading={loading} heightSize='80vh' />
        ) : (
          <div id='content'>
            <div
              id='tableFlexible'
              style={{ height: selectedRowKeys === "" ? "80vh" : "37vh" }}>
              <div
                ref={conponentPDF}
                style={{ width: "100%", paddingBottom: "10px" }}>
                <table
                  id='tblData'
                  className='table table-bordered table-style fixedHeader '>
                  <thead className=''>
                    <tr>
                      <th rowSpan={2} className='sticky st1'>
                        o
                      </th>

                      <th
                        rowSpan={2}
                        className='sticky'
                        style={{ left: "31px" }}>
                        T/R
                      </th>

                      <th
                        rowSpan={2}
                        className='sticky'
                        style={{ left: "71px" }}>
                        Irrigatsiya tizimlari nomi va asosiy suvolish nuqtalari
                      </th>

                      <th
                        rowSpan={2}
                        className='sticky'
                        style={{ left: "368px" }}>
                        O’lchov birligi
                      </th>
                      <th colSpan={monthDays(month)}>{monthName(month)}</th>
                    </tr>

                    <tr>
                      {Array(monthDays(month))
                        .fill()
                        .map((p, i) => {
                          return (
                            <th key={i}>
                              <NavLink
                                to='/asosiymanbalar/add'
                                onClick={() =>
                                  setDate(
                                    month +
                                      "-" +
                                      (i < 9 ? "0" + (i + 1) : i + 1)
                                  )
                                }>
                                {i < 9 ? "0" + (i + 1) : i + 1}
                              </NavLink>
                            </th>
                          );
                        })}
                    </tr>
                  </thead>

                  {data.length > 0
                    ? data.map((d, index) => {
                        return (
                          <tbody key={index}>
                            <tr
                              onClick={() => chiz(index)}
                              className={"tr tr" + index}>
                              <td className='sticky st1'>
                                <input type='checkbox' />
                              </td>

                              <td className='sticky' style={{ left: "31px" }}>
                                {index + 1}
                              </td>

                              <td
                                className='text-start sticky fix-with'
                                style={{ left: "71px" }}>
                                {d.manba_nomi}
                              </td>

                              <td
                                className='text-start sticky'
                                style={{ left: "368px" }}>
                                {d.birligi},
                              </td>

                              {Array(monthDays(month))
                                .fill()
                                .map((p, i) => {
                                  return (
                                    <td
                                      style={{
                                        width: "80px",
                                        maxWidth: "80px",
                                        minWidth: "80px",
                                      }}
                                      key={i}>
                                      {d["kun" + (i + 1)]}
                                    </td>
                                  );
                                })}
                            </tr>
                          </tbody>
                        );
                      })
                    : null}
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      {selectedRowKeys.length === 0 ? null : (
        <div
          className='data-content mt-3 mainpage'
          style={{ position: "relative" }}>
          <CloseOutlined
            style={{
              position: "absolute",
              top: 0,
              right: 10,
              zIndex: 9,
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={close}
          />
          <Card>
            {data[selectedRowKeys].lat !== null &&
            data[selectedRowKeys].lan !== null ? (
              <Minimap
                location={[
                  data[selectedRowKeys].lat,
                  data[selectedRowKeys].lan,
                ]}
                locations={[]}
                zoom={13}
              />
            ) : null}
          </Card>

          <Chart4 datas={data[selectedRowKeys]} month={month} />
        </div>
      )}
    </>
  );
}

export default Kunlik;
